import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Chart } from "primereact/chart";
import { Dialog } from "primereact/dialog";
import CommonReportFilter from "./CommonReportFilter";

const CustomReport = () => {
    const navigate = useNavigate();
    // Dialog start
    const [visible, setVisible] = useState(false);
    // Bar Graph code start here
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});
    const [chartData1, setChartData1] = useState({});
    const [chartOptions1, setChartOptions1] = useState({});
    const protrackReports = useSelector((state) => state.reports);
    const {
        customReportList,
        customBusinessTypeReportList,
        customPackMetrisReportList,
        customPackVolumnReportList,
    } = protrackReports;
    const jobState = useSelector((state) => state.job);
    const {
        appLanguage,
    } = jobState;
    const dispatch = useDispatch();
    let packmetricData = customReportList?.packmetric ? customReportList?.packmetric[0] : [];
    const stackedBarTopLabels = {
        id: 'stackedBarTopLabels',
        afterDatasetsDraw(chart) {
            const { ctx, data, scales: { x, y } } = chart;
            const volData = data.datasets[0]?.data || [];
            ctx.save();
            ctx.font = 'bold 11px sans-serif';
            ctx.fillStyle = '#333';
            ctx.textAlign = 'center';
            volData.forEach((val, i) => {
                const xPos = x.getPixelForValue(i);
                const yPos = y.getPixelForValue(val || 0) - 6;
                ctx.fillText(val || 0, xPos, yPos);
            });
            ctx.restore();
        },
    };

    useEffect(() => {
        const bussTypeVol = customReportList?.VolBusType ? customReportList?.VolBusType : [];
        const bussTypeVolLabels = bussTypeVol?.map(item => item.businesstypename);
        const bussTypeVolValues = bussTypeVol?.map(item => item.cnt);

        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue("--text-color");
        const textColorSecondary = documentStyle.getPropertyValue(
            "--text-color-secondary"
        );
        const surfaceBorder = documentStyle.getPropertyValue("--surface-border");
        const data = {
            labels: bussTypeVolLabels,
            datasets: [
                {
                    type: "bar",
                    label: appLanguage["report.custom.label.completed-documents"],
                    backgroundColor: '#7F7F7F',
                    data: bussTypeVolValues,
                },
                // {
                //     type: "bar",
                //     label: "Dataset 2",
                //     backgroundColor: '#C00000',
                //     data: [21, 84, 24, 75, 37, 65, 34, 30, 23],
                // },
            ],
        };
        const options = {
            maintainAspectRatio: false,
            aspectRatio: 1,
            plugins: {
                tooltips: {
                    mode: "index",
                    intersect: false,
                },
                legend: {
                    display: false
                },

                // legend: {
                //     labels: {
                //         color: textColor,
                //     },
                // },
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                        display: false,
                    },
                },
                y: {
                    stacked: true,
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                    },
                },
            },
        };
        setChartData(data);
        setChartOptions(options);
    }, [customReportList, appLanguage]);

    useEffect(() => {
        const dayOrder = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        let avgPackVol = customReportList?.AvgPAckVolume ? customReportList?.AvgPAckVolume : [];
        const sortedAvgPackVolume = [...avgPackVol]
            .sort((a, b) => dayOrder.indexOf(a.day1) - dayOrder.indexOf(b.day1))
            .map(item => ({
                ...item,
                day1: item.day1.slice(0, 3)
            }));

        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue("--text-color");
        const textColorSecondary = documentStyle.getPropertyValue(
            "--text-color-secondary"
        );
        const surfaceBorder = documentStyle.getPropertyValue("--surface-border");
        const data = {
            labels: sortedAvgPackVolume.map(item => item.day1),
            datasets: [
                {
                    type: "bar",
                    label: "C5",
                    backgroundColor: '#BFBFBF',
                    data: sortedAvgPackVolume.map(item => item.AvgC5PackSize),
                },
                {
                    type: "bar",
                    label: "C4",
                    backgroundColor: '#7F7F7F',
                    data: sortedAvgPackVolume.map(item => item.AvgC4PackSize),
                }, {
                    type: "bar",
                    label: appLanguage["report.custom.label.toltip-others"],
                    backgroundColor: '#C00000',
                    data: sortedAvgPackVolume.map(item => item.AvgOtherPackSize),
                },
            ],
        };
        const options = {
            maintainAspectRatio: false,
            aspectRatio: 1,
            plugins: {
                tooltips: {
                    mode: "index",
                    intersect: false,
                },
                // legend: {
                //     display: false
                // },
                legend: {
                    display: true,
                    position: 'bottom',
                    labels: {
                        color: textColor,
                        // usePointStyle: true,
                        padding: 20
                    },
                },
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                        display: false,
                    },
                },
                y: {
                    stacked: true,
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                    },
                },
            },
        };
        setChartData1(data);
        setChartOptions1(options);
    }, [customReportList, appLanguage]);

    const downloadCustomBusinessTypeReport = () => {
        downloadCsv(customBusinessTypeReportList, 'custom_business_type_report.csv');
    }

    const downloadCustomPackMetricsReport = () => {
        downloadCsv(customPackMetrisReportList, 'custom_pack_metrics_report.csv');
    }

    const downloadCustomPackVolumnReport = () => {
        downloadCsv(customPackVolumnReportList, 'custom_pack_volume_report.csv');
    }

    // Convert JSON to CSV
    const jsonToCsv = (jsonData) => {
        const isArray = Array.isArray(jsonData);
        if (isArray) {
            const headers = Object.keys(jsonData[0]);
            const csvRows = [];
            csvRows.push(headers.join(','));
            jsonData.forEach(item => {
                const values = headers.map(header => {
                    const value = item[header];
                    return `"${value !== null && value !== undefined ? value.toString().replace(/"/g, '""') : ''}"`;
                });
                csvRows.push(values.join(','));
            });
            return csvRows.join('\n');
        } else {
            const headers = Object.keys(jsonData);
            const values = headers.map(header => {
                const value = jsonData[header];
                return `"${value !== null && value !== undefined ? value.toString().replace(/"/g, '""') : ''}"`;
            });
            return `${headers.join(',')}\n${values.join(',')}`;
        }
    };

    // Trigger CSV download
    const downloadCsv = (jsonData, fileName) => {
        const csvData = jsonToCsv(jsonData);
        console.log('CSV Data:', csvData);
        const blob = new Blob([csvData], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    };

    return (
        <div className="custom-tab-wrapper">
            <div className="four-col-wrap">
                <div className="first-col">
                    <CommonReportFilter />
                </div>
                <div className="second-col custom-graph-wrapper">
                    <div className="box-white">
                        <h3>
                            {appLanguage["report.custom.label.volumn-by-business-type"]}
                            <span className="button-wrapper">
                                {/* <button className="download-icon"></button> */}
                                <button title="Download Source Data" className="download-icon" onClick={downloadCustomBusinessTypeReport}></button>
                                <button
                                    title="Expand Chart"
                                    className="zoom-icon"
                                    onClick={() => navigate("/custom-business-volumn-expended-report")}
                                ></button>
                            </span>
                        </h3>

                        <div className="reporting-sla-graph-wrap">
                            <Chart
                                type="bar"
                                data={chartData}
                                options={chartOptions}
                                plugins={[stackedBarTopLabels]}
                                style={{ minHeight: '365px' }}
                            />

                            <Dialog
                                header="Header"
                                visible={visible}
                                modal={false}
                                style={{ width: "50vw" }}
                                onHide={() => setVisible(false)}
                            ></Dialog>
                        </div>
                    </div>
                </div>
                <div className="third-col">
                    <div className="box-white">
                        <h3>
                            {appLanguage["report.custom.label.pack-metrics"]}
                            <span className="button-wrapper">
                                {/* <button className="download-icon"></button> */}
                                <button title="Download Source Data" className="download-icon" onClick={downloadCustomPackMetricsReport}></button>
                            </span>
                        </h3>
                        <div className="sla-matrics-box">
                            <div className="total-count-box">
                                <h5>{appLanguage["report.custom.label.total-c5"]}</h5>
                                <h4>{packmetricData?.TotalC5 ? packmetricData?.TotalC5 : 0}</h4>
                            </div>
                            <div className="total-count-box">
                                <h5>{appLanguage["report.custom.label.total-c4"]}</h5>
                                <h4>{packmetricData?.TotalC4 ? packmetricData?.TotalC4 : 0}</h4>
                            </div>
                            <div className="total-count-box">
                                <h5>{appLanguage["report.custom.label.total-others"]}</h5>
                                <h4>{packmetricData?.TotalOthers ? packmetricData?.TotalOthers : 0}</h4>
                            </div>
                        </div>
                        <ul className="pack-matrics-list">
                            <li>
                                <label>{appLanguage["report.custom.label.total-packs"]}:</label>
                                <span>{packmetricData?.totalpacks ? packmetricData?.totalpacks : 0}</span>
                            </li>
                            <li>
                                <label>{appLanguage["report.custom.label.total-sheets"]}:</label>
                                <span>{packmetricData?.totalsheets ? packmetricData?.totalsheets : 0}</span>
                            </li>
                            <li>
                                <label>{appLanguage["report.custom.label.total-images"]}:</label>
                                <span>{packmetricData?.TotalImages ? packmetricData?.TotalImages : 0}</span>
                            </li>
                            <li>
                                <label>{appLanguage["report.custom.label.total-inserts"]}:</label>
                                <span>{packmetricData?.totalinserts ? packmetricData?.totalinserts : 0}</span>
                            </li>
                            <li>
                                <label>{appLanguage["report.custom.label.average-pack-size-c5"]}:</label>
                                <span>{packmetricData?.AvgC5PackSize ? packmetricData?.AvgC5PackSize : 0}</span>
                            </li>
                            <li>
                                <label>{appLanguage["report.custom.label.average-pack-size-c4"]}:</label>
                                <span>{packmetricData?.AvgC4PackSize ? packmetricData?.AvgC4PackSize : 0}</span>
                            </li>
                            <li>
                                <label>{appLanguage["report.custom.label.average-pack-size-others"]}:</label>
                                <span>{packmetricData?.AvgOtherPackSize ? packmetricData?.AvgOtherPackSize : 0}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="fourth-col custom-graph-wrapper">
                    <div className="box-white">
                        <h3>
                            {appLanguage["report.custom.label.average-pack-volumn"]}
                            <span className="button-wrapper">
                                {/* <button className="download-icon"></button> */}
                                <button title="Download Source Data" className="download-icon" onClick={downloadCustomPackVolumnReport}></button>
                                <button
                                    title="Expand Chart"
                                    className="zoom-icon"
                                    onClick={() => navigate("/custom-average-volumn-expended-report")}
                                ></button>
                            </span>
                        </h3>

                        <div className="reporting-sla-graph-wrap">
                            <Chart
                                type="bar"
                                data={chartData1}
                                options={chartOptions1}
                                style={{ minHeight: '365px' }}
                            />

                            <Dialog
                                header="Header"
                                visible={visible}
                                modal={false}
                                style={{ width: "50vw" }}
                                onHide={() => setVisible(false)}
                            ></Dialog>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomReport;